import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useRouter } from 'next/router';

/**
 * Hook to determine if the Cancellation Fees page should be enabled.
 *
 * Priority (highest to lowest):
 * 1. URL query parameter ?confirmCancellation=true|false (always overrides)
 * 2. GrowthBook feature flag 'confirm-cancellation'
 *
 * This provides a safe way to test and gradually roll out the new
 * Cancellation Fees feature in Provider Portal.
 */
export const useConfirmCancellationEnabled = (): boolean => {
  const router = useRouter();
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.CONFIRM_CANCELLATION,
  );

  // Query param override for testing
  const queryParam = router.query['confirmCancellation'];
  if (queryParam === 'true') {
    return true;
  }
  if (queryParam === 'false') {
    return false;
  }

  return growthBookEnabled;
};
